import {
  Component,
  Input,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnvToken, SeoSegmentsToken } from '@app/core/env.tokens';

import { BreadcrumbListComponent } from '@components/shared/breadcrumb-list/breadcrumb-list.component';
import { GenericButtonWithArrow } from '@components/shared/genericButtonWithArrow/genericButtonWithArrow';
import { MatIconModule } from '@angular/material/icon';
import { HowTo } from '@models/guides/howToGuide.model';
import { Vertical } from '@models/vertical/vertical.model';
import { PriceGuide } from '@models/guides/priceGuide.model';
import { Blog } from '@models/blog.model';
import { Tip } from '@models/guides/tips.model';
import { generateEntityUrl } from '@helpers/generateEntityUrl';

type EntityDataItem = PriceGuide | Vertical | any;
@Component({
  imports: [
    BreadcrumbListComponent,
    CommonModule,
    GenericButtonWithArrow,
    MatIconModule,
  ],
  selector: 'app-hub-header',
  templateUrl: './hub-header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./hub-header.component.scss'],
})
export class HubHeaderComponent {
  protected readonly env = inject(EnvToken);
  protected readonly seg = inject(SeoSegmentsToken);
  @Input() entityData!: EntityDataItem[];
  @Input() title!: string;
  @Input() description!: string;
  @Input() headerImg?: string;
  @Input() dataIsLoading: boolean = false;
  @Input() partsOfUrl: any;
  @Input() verticalSlug?: string;
  @Input() headCat?: string;
  @Input() subCat?: string | null | undefined;

  public generateUrl(
    entity: HowTo | Vertical | PriceGuide | Blog | Tip,
  ): string {
    return generateEntityUrl(
      this.seg,
      entity,
      entity?.mainCategory?.slug || this?.headCat,
      this.subCat,
    );
  }
}
